<app-header></app-header>
<app-hero></app-hero>

<main id="main">
  <app-about></app-about>
  <!-- <app-facts></app-facts> -->
  <app-skills></app-skills>
  <app-resume></app-resume>
  <app-portafolio></app-portafolio>
  <!-- <app-services></app-services> -->
  <!-- <app-testimoniales></app-testimoniales> -->
  <!-- <app-contact></app-contact> -->
</main>
<app-footer></app-footer>
<!-- End #main -->
